import type { OrgTreeNode } from '@/entities/organization/model/organizationSchema';

export function collectDepartments(nodes: OrgTreeNode[]): string[] {
  return [...new Set(nodes.filter((n) => n.department).map((n) => n.department!))].sort();
}
